module.exports = __webpack_public_path__ + "static/media/18ECA33.dc3b1696.jpg";